// Dokumentace https://cncenter.atlassian.net/wiki/spaces/KB/pages/219807745/UW+galerie

import * as Sentry from '@sentry/browser';
import { gallerySlideOrScroll as slideOrScroll } from './gallerySlideOrScroll';
import { galleryState as state } from './galleryState';
import { galleryConfigure as configure } from './galleryConfigure';
import { galleryTrimTitle as trimTitle } from './galleryTrimTitle';
import { galleryObserveActiveItem as observeActiveItem } from './galleryObserveActiveItem';
import { galleryScrollUpToUrlFotoParam as scrollUpToUrlFotoParam } from './galleryScrollUpToUrlFotoParam';
import { galleryGTMTracking as addGTMBaseEvents } from './galleryGTMTracking';
import { galleryAddToggleViewButtonsListeners as addToggleViewButtonsListeners } from './galleryAddToggleViewButtonsListeners';
import { galleryResizeItems as resizeItems } from './galleryResizeItems';
import { GTMTrack, GTMPageBodyIsReady } from '@utils/dataLayer';

import breakpoints from '@breakpoints';

const Gallery = (): (() => void) => {
  try {
    let changeBreakpointIterator = 0;

    // Nastavení konfigurace ze TWIGu do state v .TS
    configure();

    // Dynamické chování dle breakpointu desktop/mobile
    const mediaQuery = window.matchMedia(breakpoints.desktop);
    const dynamicBehaviourUpToDevice = (): void => {
      // Nastavit isDesktop
      state.setIsDesktop(mediaQuery.matches);

      // Nastavit výšky položek kvůli správným hodnotám activeItem
      resizeItems();

      // Mobil: scroller / desktop: slider
      slideOrScroll();

      // Rekonfigugarece listenerů
      state.configureListeners();

      // GTM | změna velikosti viewportu
      if (changeBreakpointIterator > 0)
        GTMTrack('gallery_resize', {
          gallery: {
            type: state.getIsDesktop() ? 'commonGallery' : 'verticalGallery',
          },
        });

      changeBreakpointIterator++;
    };

    // Inicializace
    dynamicBehaviourUpToDevice();
    // Sledování změny velikosti viewportu ---start---
    const handleMediaQueryChange = () => {
      dynamicBehaviourUpToDevice();
    };
    if (mediaQuery) mediaQuery.addEventListener('change', handleMediaQueryChange);
    // Sledování změny velikosti viewportu ---end---

    // Tento listener je nutný i mimo základní sledování přes breakpoint mobile/desktop, např. pro různé šířky mobilu
    window.addEventListener('resize', () => {
      if (window.devicePixelRatio === 1) {
        resizeItems();
      }
    });

    /*
     Musí být až po dynamicBehaviourUpToDevice() - kvůli nastavení isDesktop
      */
    // Sledovat aktuální položku
    GTMPageBodyIsReady(() => observeActiveItem());

    // Přidat GTM eventy
    addGTMBaseEvents();

    // Zkrátit title (dle zařízení)
    trimTitle();

    // Pokud url obsahuje parametr ?foto= tak přepnout na slideru/scrolleru na danou fotku
    scrollUpToUrlFotoParam();

    // Po kliknutí na tlačítko 'Přehled fotografií'
    addToggleViewButtonsListeners();

    return () => {
      // Vyčistit event listenery
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  } catch (err) {
    Sentry.captureException(err);
    return () => {};
  }
};

export default Gallery;
